(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-inspired-sdg"] && !Shopify.designMode) return;
  try {
    
  class GetInspiredSdgGallery extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.listenersAttached = false;
    }

    connectedCallback() {
      this.refresh();
      if (!this.tabs.length || !this.panels.length) return;

      if (!this.listenersAttached) {
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.listenersAttached = true;
      }
    }

    disconnectedCallback() {
      if (this.listenersAttached) {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.listenersAttached = false;
      }
    }

    refresh() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      event.preventDefault();
      let index = this.tabs.indexOf(tab);
      if (index === -1) {
        this.refresh();
        index = this.tabs.indexOf(tab);
        if (index === -1) return;
      }

      this.activate(index);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      let currentIndex = this.tabs.indexOf(tab);
      if (currentIndex === -1) {
        this.refresh();
        currentIndex = this.tabs.indexOf(tab);
        if (currentIndex === -1) return;
      }

      const { key } = event;
      let nextIndex;

      if (key === 'ArrowUp' || key === 'ArrowLeft') {
        nextIndex = currentIndex - 1;
      } else if (key === 'ArrowDown' || key === 'ArrowRight') {
        nextIndex = currentIndex + 1;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      const index = (nextIndex + this.tabs.length) % this.tabs.length;
      this.activate(index, true);
    }

    activate(index, focus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        panel.toggleAttribute('inert', !isActive);
        panel.tabIndex = isActive ? 0 : -1;
      });

      if (focus) {
        this.tabs[index]?.focus();
      }
    }
  }

  if (!customElements.get('get-inspired-sdg-gallery')) {
    customElements.define('get-inspired-sdg-gallery', GetInspiredSdgGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-2-sdg"] && !Shopify.designMode) return;
  try {
    
  class Hero2SdgCarousel extends HTMLElement {
    constructor() {
      super();
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.autoplayInterval = Number.parseInt(this.dataset.autoplayInterval || '0', 10);
      this.currentIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

      if (!this.tabs.length || !this.slides.length || !this.panels.length) return;

      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      }

      this.breakpointMedia = window.matchMedia('(min-width: 750px)');

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.breakpointMedia.addEventListener('change', this.handleBreakpointChange);

      this.activate(this.currentIndex, { restartAutoplay: false });
      this.scheduleAutoplay();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.breakpointMedia?.removeEventListener('change', this.handleBreakpointChange);
      this.clearAutoplay();
    }

    handleClick(event) {
      const toggleButton = event.target.closest('[data-video-toggle]');
      if (toggleButton) {
        event.preventDefault();
        this.toggleVideoPlayback(toggleButton);
        return;
      }

      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      event.preventDefault();

      const index = this.tabs.indexOf(tab);
      if (index === -1) return;

      this.activate(index);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      const currentIndex = this.tabs.indexOf(tab);
      if (currentIndex === -1) return;

      const { key } = event;
      let nextIndex;

      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        nextIndex = currentIndex - 1;
      } else if (key === 'ArrowRight' || key === 'ArrowDown') {
        nextIndex = currentIndex + 1;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();

      const index = (nextIndex + this.tabs.length) % this.tabs.length;
      this.activate(index, { focusTab: true });
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.clearAutoplay();
        return;
      }

      this.syncVideoPlayback();
      this.scheduleAutoplay();
    }

    handleBreakpointChange() {
      this.syncVideoPlayback();
    }

    handleBlockDeselect(event) {
      const { target } = event;
      if (!(target instanceof HTMLElement) || !this.contains(target)) return;

      this.scheduleAutoplay();
    }

    handleBlockSelect(event) {
      const { target } = event;
      if (!(target instanceof HTMLElement) || !this.contains(target)) return;

      const panel = target.closest('[role="tabpanel"]');
      const slide = target.closest('[data-slide]');
      const index = panel ? this.panels.indexOf(panel) : this.slides.indexOf(slide);
      if (index === -1) return;

      this.clearAutoplay();
      this.activate(index, { restartAutoplay: false });
    }

    activate(index, { focusTab = false, restartAutoplay = true } = {}) {
      const normalizedIndex = (index + this.tabs.length) % this.tabs.length;
      this.currentIndex = normalizedIndex;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === normalizedIndex;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === normalizedIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === normalizedIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.tabIndex = isActive ? 0 : -1;
        panel.toggleAttribute('inert', !isActive);
      });

      this.syncVideoPlayback();

      if (focusTab) {
        this.tabs[normalizedIndex]?.focus();
      }

      if (restartAutoplay) {
        this.scheduleAutoplay();
      }
    }

    scheduleAutoplay() {
      this.clearAutoplay();

      if (this.tabs.length < 2 || !this.autoplayInterval) return;

      this.autoplayTimer = window.setTimeout(() => {
        if (document.hidden) {
          this.scheduleAutoplay();
          return;
        }

        this.activate(this.currentIndex + 1, { restartAutoplay: false });
        this.scheduleAutoplay();
      }, this.autoplayInterval);
    }

    clearAutoplay() {
      if (!this.autoplayTimer) return;

      window.clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    toggleVideoPlayback(button) {
      const slide = button.closest('[data-slide]');
      const videoWrapper = Array.from(slide?.querySelectorAll('.hero-2-sdg__video-wrapper') || []).find(
        (wrapper) => wrapper.offsetParent !== null
      );
      const video = videoWrapper?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        video.dataset.userPaused = 'false';
        video.play();
        this.updateVideoToggle(button, false);
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
        this.updateVideoToggle(button, true);
      }
    }

    updateVideoToggle(button, isPaused) {
      button.classList.toggle('is-paused', isPaused);
      button.setAttribute('aria-label', isPaused ? button.dataset.labelPlay : button.dataset.labelPause);
      button.setAttribute('aria-pressed', String(isPaused));
    }

    syncVideoPlayback() {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;
        const videoWrappers = slide.querySelectorAll('.hero-2-sdg__video-wrapper');

        videoWrappers.forEach((videoWrapper) => {
          const video = videoWrapper.querySelector('video');
          if (!video) return;

          if (isActive && video.offsetParent !== null && video.dataset.userPaused !== 'true') {
            video.play();
          } else {
            video.pause();
          }

        });

        const playbackWrapper = Array.from(videoWrappers).find((videoWrapper) => videoWrapper.offsetParent !== null) || videoWrappers[0];
        const playbackVideo = playbackWrapper?.querySelector('video');
        if (!playbackVideo) return;

        slide.querySelectorAll('[data-video-toggle]').forEach((toggleButton) => {
          this.updateVideoToggle(toggleButton, playbackVideo.paused);
        });
      });
    }
  }

  if (!customElements.get('hero-2-sdg-carousel')) {
    customElements.define('hero-2-sdg-carousel', Hero2SdgCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-sdg"] && !Shopify.designMode) return;
  try {
    
  class HeroSdgTabs extends HTMLElement {
    constructor() {
      super();
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      event.preventDefault();
      const index = this.tabs.indexOf(tab);
      if (index === -1) return;

      this.activate(index);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      const currentIndex = this.tabs.indexOf(tab);
      if (currentIndex === -1) return;

      const { key } = event;
      let nextIndex;

      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        nextIndex = currentIndex - 1;
      } else if (key === 'ArrowRight' || key === 'ArrowDown') {
        nextIndex = currentIndex + 1;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      const index = (nextIndex + this.tabs.length) % this.tabs.length;
      this.activate(index, true);
    }

    handleBlockSelect(event) {
      const { target } = event;
      if (!(target instanceof HTMLElement) || !this.contains(target)) return;

      const panel = target.closest('[role="tabpanel"]');
      const index = this.panels.indexOf(panel);
      if (index === -1) return;

      this.activate(index);
    }

    activate(index, focus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        panel.toggleAttribute('inert', !isActive);
        panel.tabIndex = isActive ? 0 : -1;
      });

      if (focus) {
        this.tabs[index]?.focus();
      }
    }
  }

  if (!customElements.get('hero-sdg-tabs')) {
    customElements.define('hero-sdg-tabs', HeroSdgTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
